import cn from 'classnames'
import { AnchorHTMLAttributes, ButtonHTMLAttributes, ElementType, forwardRef, ReactElement } from 'react'

import styles from './IconButton.module.scss'

type IconButtonSize = 'sm' | 'md'
type IconButtonVariant = 'primary' | 'secondary'

type IconButtonProps = ButtonHTMLAttributes<HTMLElement> &
  AnchorHTMLAttributes<HTMLElement> & {
    as?: ElementType
    variant?: IconButtonVariant
    size?: IconButtonSize
    children: ReactElement
  }

const IconButton = forwardRef<HTMLElement, IconButtonProps>(
  ({ as: Element = 'button', variant = 'primary', size = 'md', type, className, children, ...elementProps }, ref) => {
    return (
      <Element
        type={Element === 'button' && !type ? 'button' : type}
        ref={ref}
        className={cn(styles.root, styles[variant], styles[size], className)}
        {...elementProps}
      >
        {children}
      </Element>
    )
  }
)

export default IconButton
